import React from "react";
import { AiFillHtml5 } from "react-icons/ai";
import "./skills.styles.css";
import { FaCss3Alt } from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io5";
import { IoLogoNpm } from "react-icons/io5";
import { RiReactjsLine } from "react-icons/ri";
import { SiTailwindcss } from "react-icons/si";
import { SiMaterialui } from "react-icons/si"
import Fade from "react-reveal";
const Skills = () => {
  return (
    <>
    <div id="skills">
    <Fade duration={1000}>
    <div className="row">
    <h1 className="pt-3 text-center font-details pb-3 headingTop">SKILLS</h1>
    <div class="flex-container">
  <div class="flex-item-left">
    <AiFillHtml5 size={98}  className="top-react-icons"/>
    <p style={{color:"#ffffff",fontSize:"25px",textAlign:"center",paddingLeft:"10px",paddingRight:"10px",paddingTop:"8px"}}>HTML5</p>
    </div>
    <div class="flex-item-left">
    <FaCss3Alt  size={91} className= "top-react-icons"/>
    <p style={{color:"#ffffff",fontSize:"25px",textAlign:"center",paddingLeft:"10px",paddingRight:"10px",paddingTop:"12px"}}>CSS3</p>
    </div>
    <div class="flex-item-left">
    <IoLogoJavascript  size={88} className= "top-react-icons"/>
    <p style={{color:"#ffffff",fontSize:"25px",textAlign:"center",paddingLeft:"10px",paddingRight:"10px",paddingTop:"12px"}}>Javascript</p>
    </div>
    <div class="flex-item-left">
    <RiReactjsLine  size={100} className= "top-react-icons"/>
    <p style={{color:"#ffffff",fontSize:"25px",textAlign:"center",paddingLeft:"10px",paddingRight:"10px",paddingTop:"7px"}}>React JS</p>
    </div>
    <div class="flex-item-left">
    <IoLogoNpm  size={96} className= "top-react-icons"/>
    <p style={{color:"#ffffff",fontSize:"25px",textAlign:"center",paddingLeft:"10px",paddingRight:"10px",paddingTop:"5px"}}>N P M </p>
    </div>
    <div class="flex-item-left">
    <SiMaterialui  size={92} className= "top-react-icons"/>
    <p style={{color:"#ffffff",fontSize:"25px",textAlign:"center",paddingLeft:"10px",paddingRight:"10px",paddingTop:"12px"}}>Material UI</p>
    </div>
    <div class="flex-item-left">
    <SiTailwindcss  size={92} className= "top-react-icons"/>
    <p style={{color:"#ffffff",fontSize:"25px",textAlign:"center",paddingLeft:"10px",paddingRight:"10px",paddingTop:"12px"}}>Tailwindcss</p>
    </div>
</div>
</div>
</Fade>
</div>
    </>
  );
};

export default Skills;
